module.exports = __webpack_public_path__ + "img/logoOpacity.78357fea.png";